import merge from 'lodash/merge';
import config from '../../config';
import RestEntityAPI from './restEntityAPI';
import fetch, { toQueryString } from '../fetch';

const options = {
  entityName: 'jobManage',
  endpoint: `${config.apiUrl}/v1/job-manage`,
};

const JobManageAPI = () => {
  const sponsorshipCartEndpoint = `${options.endpoint}/sponsorship-cart`;
  const jobPostingEndpoint = `${options.endpoint}/job-posting`;
  const jobPostingListEndpoint = `${options.endpoint}/job-posting-list`;
  const dailyReportEndpoint = `${options.endpoint}/report/daily-report`;
  const parentAPI = RestEntityAPI(options);

  const createCart = async (jobId) => {
    const baseUrl = `${sponsorshipCartEndpoint}/${jobId}/create`;

    try {
      await fetch(baseUrl, {
        method: 'POST',
        fullResponse: true,
      });
    } catch (error) {
      throw error;
    }
  };

  const updateJobSponsorship = async (data, profileKey) => {
    try {
      const headers = (profileKey != null) ? { 'X-Profile-Key': profileKey } : {};
      return await fetch(jobPostingEndpoint, { method: 'PATCH', body: { data }, headers });
    } catch (error) {
      throw error;
    }
  };

  const getSponsorshipItems = async (jobId) => {
    const baseUrl = `${sponsorshipCartEndpoint}/${jobId}`;

    try {
      const response = await fetch(baseUrl, {
        method: 'GET',
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const createSponsorship = async (data) => {
    const baseUrl = `${jobPostingEndpoint}`;

    try {
      const response = await fetch(baseUrl, {
        method: 'POST',
        body: {
          data,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const addSponsorshipItem = async (jobId, options) => {
    const baseUrl = `${sponsorshipCartEndpoint}/${jobId}`;

    try {
      const response = await fetch(baseUrl, {
        method: 'POST',
        body: {
          data: {
            orders: options,
          },
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const deleteSponsorshipItem = async (jobId, options) => {
    const { postingId } = options;
    const baseUrl = `${sponsorshipCartEndpoint}/${jobId}${toQueryString({ posting_id: postingId })}`;
    try {
      const response = await fetch(baseUrl, {
        method: 'DELETE',
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const getDailyReport = async (options) => {
    const baseUrl = `${dailyReportEndpoint}${toQueryString(options)}`;
    const response = await fetch(baseUrl, {
      method: 'GET',
    });
    return response.data;
  };

  const getDynamicClickValues = async (price) => {
    const baseUrl = `${jobPostingEndpoint}/clicks${toQueryString({ price })}`;
    try {
      const response = await fetch(baseUrl, {
        method: 'GET',
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const getSponsorshipPartners = async (jobId) => {
    const baseUrl = `${jobPostingEndpoint}/${jobId}/info`;
    try {
      const response = await fetch(baseUrl, {
        method: 'GET',
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const getJobSponsor = async ({ jobId, ctx }) => {
    const getUrl = `${jobPostingListEndpoint}/${jobId}`;
    try {
      return await fetch(getUrl, { method: 'GET', ctx: ctx || {} });
    } catch (error) {
      throw error;
    }
  };

  const getJobPostingTransaction = async (transactionId, requestOptions = {}, ctx = {}) => {
    try {
      return await fetch(`${jobPostingEndpoint}/transaction/${transactionId}`, {
        method: 'GET',
        ...requestOptions,
        ctx,
      });
    } catch (error) {
      return error;
    }
  };

  const getOverviewReport = async (params, requestOptions = {}, ctx = {}) => {
    try {
      return await fetch(`${options.endpoint}/report/overview-report${toQueryString(params)}`, {
        method: 'GET',
        ...requestOptions,
        ctx,
      });
    } catch (error) {
      return error;
    }
  };

  const getExpiredJobSponsorships = async ({ params, ctx }) => {
    const getUrl = `${jobPostingEndpoint}/expired/report${toQueryString(params)}`;
    try {
      return await fetch(getUrl, { method: 'GET', ctx: ctx || {} });
    } catch (error) {
      throw error;
    }
  };

  return merge({}, { ...parentAPI }, {
    createCart,
    addSponsorshipItem,
    getSponsorshipItems,
    deleteSponsorshipItem,
    getDynamicClickValues,
    getSponsorshipPartners,
    updateJobSponsorship,
    getJobSponsor,
    createSponsorship,
    getJobPostingTransaction,
    getOverviewReport,
    getExpiredJobSponsorships,
    getDailyReport,
  });
};

export default JobManageAPI;
